import { render, staticRenderFns } from "./ModalProductTimeline.vue?vue&type=template&id=5423436e&scoped=true&"
import script from "./ModalProductTimeline.vue?vue&type=script&lang=js&"
export * from "./ModalProductTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductTimeline.vue?vue&type=style&index=0&id=5423436e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423436e",
  null
  
)

export default component.exports